/* Centralized day.js setup
Ensures UTC plugin is applied once and used consistently across the app.
 */

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default dayjs;
